import React from "react";
import Layout from "components/layout";
import SEO from "components/seo";
import MainHeader from "components/HeaderMain";
import MainLineupExhibit from "components/MainLineupExhibit";

const IndexPage = () => {
  return (
    <Layout>
      <SEO title="Welcome" />
      <div className="container" style={{ marginTop: 0 }}>
        <MainHeader />
        <MainLineupExhibit />
      </div>
    </Layout>
  );
};

export default IndexPage;
